// extracted by mini-css-extract-plugin
export default {"confirmMessage":"ConfirmDialog_confirmMessage__Li3IC","confirmActions":"ConfirmDialog_confirmActions__4muD6"};